var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-4 p-2"},[_c('h4',{staticClass:"title-card"},[_vm._v(_vm._s(_vm.titulo))]),_c('p',{staticClass:"text-card mt-4"},[_vm._v(_vm._s(_vm.texto))])])}
var staticRenderFns = []

export { render, staticRenderFns }